import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import * as serviceWorker from './serviceWorker';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import Auth from '@starterapp/shared-services/authentication/AuthContext';
import BaseRoute from '@starterapp/shared-services/BaseRoute';
import PrivateRoute from '@starterapp/shared-services/authentication/PrivateRoute';

import Authenticate from './pages/Authenticate';
import PoiRedirect from './pages/PoiRedirect';
import Logout from './pages/Logout';
import { GlobalStyle, theme } from '@snsw-gel/react';
import { StarterAppProvider } from './store/StarterAppContext';
import { history } from '@starterapp/shared-services/history';

import CurrentStatusPage from './pages/CurrentStatus';
import BeforeYouStart from './pages/BeforeYouStart';

import EligibilityCheckPage from './pages/ApplicationFlow/EligibilityCheckPage';
import ProfileConnectRedirect from './pages/ApplicationFlow/ProfileConnectRedirect';
import ProfileConnectLanding from './pages/ApplicationFlow/ProfileConnectLanding';
import  MarketingPreferencesPage from './pages/ApplicationFlow/ MarketingPreferences';
import SelectedCardPage from './pages/ApplicationFlow/SelectedCard';
import ReviewPage from './pages/ApplicationFlow/Review';
import ConfirmationPage from './pages/ApplicationFlow/Confirmation';
import ApplicationError from './pages/ApplicationFlow/ApplicationError';
import AddressErrorPage from './pages/ApplicationFlow/AddressError';
import AgeErrorPage from './pages/ApplicationFlow/AgeError';
import CardErrorPage from './pages/ApplicationFlow/CardError';
import ResidencyErrorPage from './pages/ApplicationFlow/ResidencyError';

import ValidateCardNumber from './pages/LinkingFlow/ValidateCardNumber';
import LinkingError from './pages/LinkingFlow/LinkingError';

import UpgradeCard from './pages/ChangeDetailFlows/UpgradeCard';
import ReplaceCard from './pages/ChangeDetailFlows/ReplaceCard';
import ChangeMarketingDetails from './pages/ChangeDetailFlows/ChangeMarketingDetails';
import CancelCard from './pages/ChangeDetailFlows/CancelCard';
import ChangeDetailsConfirmation from './pages/ChangeDetailFlows/ChangeDetailsConfirmation';
import { setGlobalNavUri ,GlobalNav} from "@snsw/react-global-nav";
import './global.scss';


setGlobalNavUri(process.env.REACT_APP_GLOBAL_NAV_HOST, {
  "x-api-key": process.env.REACT_APP_GLOBAL_NAV,
})


// TODO: make this configurable
const appName = 'Seniors Card';  // Show consumers which version of Starter App they're using
const createPageTitle = (title = 'Home Page') => `${title} | ${appName}`;


ReactDOM.render(
    <React.StrictMode>
        <StarterAppProvider>
            <ThemeProvider theme={theme}>
                <GlobalStyle />
                <GlobalNav>
                <div id="main-content"  tabindex="-1">
                <main>
                    <Router basename={process.env.PUBLIC_URL} history={history}>
                        <Auth>
                            <Switch>
                                <BaseRoute
                                    path='/currentCardStatus'
                                    pageTitle={createPageTitle('Current Card Status')}
                                    component={CurrentStatusPage}
                                />

                                {/* Application flow */}
                                <BaseRoute
                                    exact
                                    path='/'
                                    pageTitle={createPageTitle('Before You Start')}
                                    component={BeforeYouStart}
                                />
                                <BaseRoute
                                    exact
                                    path='/eligibilityCheck'
                                    pageTitle={createPageTitle('Eligibility Check')}
                                    component={EligibilityCheckPage}
                                />
                                <PrivateRoute
                                    path='/profileConnectRedirect'
                                    pageTitle={createPageTitle('Profile Connect')}
                                    component={ProfileConnectRedirect}
                                />
                                <PrivateRoute
                                    path='/profileConnectLanding'
                                    pageTitle={createPageTitle('Profile Connect')}
                                    component={ProfileConnectLanding}
                                />
                                <PrivateRoute
                                    path='/selectedCard'
                                    pageTitle={createPageTitle('Your Eligibility')}
                                    component={SelectedCardPage}
                                    />
                                <PrivateRoute
                                    path='/applyMarketingPreferences'
                                    pageTitle={createPageTitle('Marketing Preferences')}
                                    component={MarketingPreferencesPage}
                                />
                                <PrivateRoute
                                    path='/review'
                                    pageTitle={createPageTitle('Review and Submit')}
                                    component={ReviewPage}
                                />
                                <PrivateRoute
                                    path='/confirmation'
                                    pageTitle={createPageTitle('Application Received')}
                                    component={ConfirmationPage}
                                />
                                <BaseRoute
                                    path='/applicationError'
                                    pageTitle={createPageTitle('Error')}
                                    component={ApplicationError}
                                />
                                <BaseRoute
                                    path='/addressError'
                                    pageTitle={createPageTitle('Error')}
                                    component={AddressErrorPage}
                                />
                                 <BaseRoute
                                    path='/ageError'
                                    pageTitle={ createPageTitle('Error') }
                                    component={ AgeErrorPage }
                                />
                                 <BaseRoute
                                    path='/cardError'
                                    pageTitle={ createPageTitle('Error') }
                                    component={ CardErrorPage }
                                />
                                   <BaseRoute
                                    path='/residencyError'
                                    pageTitle={ createPageTitle('Error') }
                                    component={ ResidencyErrorPage }
                                />
                                {/* Link card to MyAccount flow */}
                                <PrivateRoute
                                    path='/link/validateCard'
                                    pageTitle={createPageTitle('Link your card')}
                                    component={ValidateCardNumber}
                                />
                                <BaseRoute
                                    path='/link/linkingError'
                                    pageTitle={createPageTitle('Error')}
                                    component={LinkingError}
                                />
                                {/* Change Details flows */}
                                <PrivateRoute
                                    path='/convertCard'
                                    pageTitle={createPageTitle('Convert your Senior Savers Card')}
                                    component={UpgradeCard}
                                />
                                <PrivateRoute
                                    path='/replaceCard'
                                    pageTitle={createPageTitle('Replace your card')}
                                    component={ReplaceCard}
                                />
                                <PrivateRoute
                                    path='/marketingPreferences'
                                    pageTitle={createPageTitle('Manage your marketing preferences')}
                                    component={ChangeMarketingDetails}
                                />
                                <PrivateRoute
                                    path='/cancelCard'
                                    pageTitle={createPageTitle('Cancel your card')}
                                    component={CancelCard}
                                />
                                <PrivateRoute
                                    path='/changeDetailsConfirmation'
                                    pageTitle={createPageTitle('Confirmation')}
                                    component={ChangeDetailsConfirmation}
                                />
                                {/* Redirects */}
                                <BaseRoute exact
                                    path='/logout'
                                    component={Logout} />
                                <BaseRoute
                                    path='/authenticate'
                                    component={Authenticate} />
                                <BaseRoute
                                    path='/poi-redirect'
                                    component={PoiRedirect} />
                            </Switch>
                        </Auth>
                    </Router>
                </main>
                </div>
                </GlobalNav>
            </ThemeProvider>
        </StarterAppProvider>
    </React.StrictMode>
   ,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
